<template>
  <v-dialog v-model="dialog" width="400">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="large"
        color="primary"
        outlined
        small
        v-on="on"
        class="mx-2"
        @click="dialog = true"
      >
        <v-icon small class="mr-2">mdi-check</v-icon>
        Review Note
      </v-btn>
      <v-tooltip v-else bottom v-on="on">
        <template v-slot:activator="{ on }">
          <v-btn x-small text v-on="on" @click="dialog = true">
            <v-icon small>mdi-check</v-icon>
          </v-btn>
        </template>
        <span> Review</span>
      </v-tooltip>
    </template>

    <v-card v-show="dialog" class="primary--text">
      <validation-observer ref="form" v-slot="{ invalid }">
        <v-card-title
          >Review Report
          <v-spacer></v-spacer>
          <v-btn icon @click="clear">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <validation-provider
            :rules="validations.approval"
            v-slot="{ errors }"
          >
            <v-chip-group
              v-model="isApproved"
              active-class="primary"
              :error-messages="errors"
            >
              <v-spacer></v-spacer>
              <v-chip :value="true" label>
                <v-icon color="green" small class="pr-2"
                  >mdi-check-outline</v-icon
                >Approve
              </v-chip>
              <v-chip :value="false" label>
                <v-icon color="red" small class="pr-2">mdi-close-outline</v-icon
                >Reject
              </v-chip>
              <v-spacer></v-spacer>
            </v-chip-group>
          </validation-provider>
          <validation-provider
            :rules="validations.comments"
            v-slot="{ errors }"
          >
            <label>Comments:</label>
            <v-textarea
              v-model="comments"
              auto-grow
              rows="2"
              outlined
              :error-messages="errors"
            ></v-textarea>
          </validation-provider>
          <v-checkbox
            v-model="sendEmail"
            label="Send email to provider"
            dense
            hide-details
          ></v-checkbox>
          <v-checkbox
            v-model="ccReviewer"
            label="Send myself copy"
            :disabled="!sendEmail"
            dense
            hide-details
          ></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :dark="!loading && !invalid"
            text
            :disabled="loading || invalid"
            @click="submitReview"
            >Submit</v-btn
          >
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["reportAssignmentId", "large"],
  data() {
    return {
      dialog: false,
      isApproved: null,
      comments: "",
      sendEmail: true,
      ccReviewer: true,
      loading: false,
    };
  },
  computed: {
    validations() {
      return {
        approval: {
          required: true,
        },
        comments: {
          required: this.isApproved === false,
        },
      };
    },
  },
  methods: {
    submitReview: async function () {
      this.loading = true;
      // emits 'save' event with callback param
      this.$emit("save", async () => {
        this.$store.commit("uxModule/setShowLoader", true);

        let message = await this.$store.dispatch(
          "reportsModule/reviewReportAssignment",
          {
            reportAssignmentId: this.reportAssignmentId,
            isApproved: this.isApproved,
            comments: this.comments,
            sendEmail: this.sendEmail,
            ccReviewer: this.ccReviewer,
          }
        );

        this.loading = false;
        this.dialog = false;
        this.$store.commit("uxModule/setShowLoader", false);

        if (message) {
          // error
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        } else {
          // success
          this.$emit("reviewed", this.isApproved);
        }

        this.clear();
      });
    },
    clear() {
      this.dialog = false;
      this.isApproved = null;
      this.comments = "";
      this.sendEmail = true;
      this.ccReviewer = true;
      this.$refs.form.reset();
    },
  },
  watch: {
    sendEmail() {
      if (!this.sendEmail) this.ccReviewer = false;
    },
    isApproved() {
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },
  },
};
</script>
